import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-42d5c229"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "toastContent"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "toastTitle"
}, " 最新版本更新通知 ", -1));
const _hoisted_3 = {
  class: "updateTime"
};
const _hoisted_4 = {
  class: "toastDetaile"
};
const _hoisted_5 = {
  class: "toastTop"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detailsTitle"
}, " 更新内容： ", -1));
const _hoisted_7 = {
  class: "toastDec"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "versionIcon"
}, null, -1));
const _hoisted_9 = {
  class: "versionText"
};
const _hoisted_10 = {
  class: "moreDetails"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "politeness"
}, "您好！为了提升产品使用体验，平台将进行以下功能的优化和改进：", -1));
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "toastBtn"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rocket"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  return _openBlock(), _createBlock(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$data.isShow ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "toastbox",
      style: _normalizeStyle({
        top: $props.top,
        left: $props.left
      })
    }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_icon, {
      name: "clock-o"
    }), _createTextVNode(" 更新于" + _toDisplayString($props.time), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, "当前版本 V " + _toDisplayString($props.version), 1)])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", {
      class: "politenessContent",
      innerHTML: $props.content
    }, null, 8, _hoisted_12)])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
      class: "toastMenu close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.prompt && $options.prompt(...args))
    }, " 不再提示 "), _createElementVNode("div", {
      class: "toastMenu primary",
      onClick: _cache[1] || (_cache[1] = $event => $data.isShow = !$data.isShow)
    }, " 我知道了 ")]), _hoisted_14, _createElementVNode("div", {
      class: "closeToast",
      onClick: _cache[2] || (_cache[2] = $event => $data.isShow = !$data.isShow)
    })])], 4)) : _createCommentVNode("", true)]),
    _: 1
  });
}